import { useState } from 'react'

import { Box, Card, RadioButton, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { toCents } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import { amountWithCurrency } from 'modules/finance/lib/budgets'

export type BudgetExceededOptions = 'increaseBudget' | 'changeAllocation'

export interface BudgetExceededAmounts {
  budgetAmount: number
  allocatedAmount: number
  totalAllocatedAmount: number
  maxAllocationAmount: number
}

interface Props {
  size?: 'small' | 'medium'
  currency: string
  amounts: BudgetExceededAmounts
  onSelect: (option: BudgetExceededOptions) => void
}
const BudgetExceededOptionSelector = ({ size = 'medium', currency, amounts, onSelect }: Props) => {
  const {
    access: { locale },
  } = useCurrentSession()
  const [selected, setSelected] = useState<BudgetExceededOptions>()

  const handleSelect = (option: BudgetExceededOptions) => {
    setSelected(option)
    onSelect(option)
  }

  return (
    <Box flexDirection={size === 'small' ? 'column' : 'row'} gap="s16">
      <Box width="full">
        <Card
          onClick={() => {
            handleSelect('increaseBudget')
          }}
        >
          <Card.Title
            size={size}
            action={
              <RadioButton
                size="medium"
                checked={selected == 'increaseBudget'}
                value="increaseBudget"
                onChange={() => {}}
              />
            }
          >
            {i18n.t('budgets.budget_exceeded_option_selector.card_1.title')}
          </Card.Title>
          <Card.Content>
            <Text.Normal>
              {i18n.tView('budgets.budget_exceeded_option_selector.card_1.description', {
                previousLimit: (
                  <Text size="300" weight="semibold">
                    {amountWithCurrency(toCents(amounts.budgetAmount), currency, locale)}
                  </Text>
                ),

                newLimit: (
                  <Text size="300" weight="semibold">
                    {amountWithCurrency(toCents(amounts.totalAllocatedAmount), currency, locale)}
                  </Text>
                ),
              })}
            </Text.Normal>
          </Card.Content>
        </Card>
      </Box>
      {amounts.maxAllocationAmount > 0 && (
        <Box width="full">
          <Card
            onClick={() => {
              handleSelect('changeAllocation')
            }}
          >
            <Card.Title
              size={size}
              action={
                <RadioButton
                  size="medium"
                  checked={selected == 'changeAllocation'}
                  onChange={() => {}}
                  value="changeAllocation"
                />
              }
            >
              {i18n.t('budgets.budget_exceeded_option_selector.card_2.title')}
            </Card.Title>
            <Card.Content>
              <Text.Normal>
                {i18n.tView('budgets.budget_exceeded_option_selector.card_2.description', {
                  newAmount: (
                    <Text size="300" weight="semibold">
                      {amountWithCurrency(toCents(amounts.maxAllocationAmount), currency, locale)}
                    </Text>
                  ),
                })}
              </Text.Normal>
            </Card.Content>
          </Card>
        </Box>
      )}
    </Box>
  )
}

export default BudgetExceededOptionSelector
